// extracted by mini-css-extract-plugin
var _1 = "webpack-containers-Review-StudyScreening-TrialExpiryBanner-TrialExpiryBanner-module__desktopOnly";
export { _1 as "desktopOnly" }
